// src/components/CatalogData.js
export const LOCAL_CATALOG = [
     {
    id: 30,
    name: "WASTE WATER PUMP",
    category: "PUMP",
    image: "/images/Images(41).jpeg"        // public/images/winch.jpg
  },
  {
    id: 5,
    name: "SUBMERCIBLE PUMP",
    category: "PUMP",
    image: "/images/Images(5).png"        // public/images/winch.jpg
  },
  {
    id: 6,
    name: "ASTOR SUBMERCIBLE PUMP",
    category: "PUMP",
    image: "/images/Images(6).jpeg"        // public/images/winch.jpg
  },
  {
    id: 7,
    name: "CENTIFUGAL WATER PUMP",
    category: "PUMP",
    image: "/images/Images(7).png"        // public/images/winch.jpg
  },
 
 {
    id: 27,
    name: "CENTRIFUGAL PUMP MOTOR",
    category: "PUMP",
    image: "/images/Images(38).jpeg"        // public/images/winch.jpg
  },
  
 
  
  {
    id: 29,
    name: "CENTRIFUGAL PUMP MOTOR",
    category: "PUMP",
    image: "/images/Images(40).jpeg" // public/images/winch.jpg
  },

  {
    id: 23,
   name: "AZTOR SUBMERCIBLE PUMP",
    category: "PUMP",
    image: "/images/Images(34).png"   // public/images/winch.jpg
  },
  
  {
    id: 24,
    name: "AZTOR SUBMERCIBLE PUMP",
    category: "PUMP",
    image: "/images/Images(35).png"        // public/images/winch.jpg
  },
  
 {
    id: 14,
    name: "CENTRIFUGAL WATER PUMP",
    category: "PUMP",
    image: "/images/Images(19).jpeg"        // public/images/winch.jpg
  },
  
  {
    id: 26,
    name: "SUBMERCIBLE PUMP",
    category: "PUMP",
    image: "/images/Images(37).jpeg"        // public/images/winch.jpg
  },
  
  {
    id: 18,
    name: "AZTOR SUBMERCIBLE PUMP",
    category: "PUMP",
    image: "/images/Images(29).png"        // public/images/winch.jpg
  },
  
   {
    id: 28,
    name: "SS PREASURE PUMP",
    category: "PUMP",
    image: "/images/Images(39).jpeg"        // public/images/winch.jpg
  },
  {
    id: 11,
    name: "WASTE WATER PUMP",
    category: "PUMP",
    image: "/images/Images(12).png"        // public/images/winch.jpg
  },
  {
    id: 12,
    name: "CENTRIFUGAL PUMP MOTOR",
    category: "PUMP",
    image: "/images/Images(13).png"        // public/images/winch.jpg
  },
  {
    id: 13,
    name: "CENTRIFUGAL PUMP MOTOR",
    category: "PUMP",
    image: "/images/Images(14).png"        // public/images/winch.jpg
  },
  
 
  

  
  {
    id: 16,
    name: "FLITER WATER PUMP",
    category: "PUMP",
    image: "/images/Images(21).png"        // public/images/winch.jpg
  },
  

  {
    id: 1,
    name: "ALIKEL GEAR MOTOR",
    category: "GEAR MOTOR",
    image: "/images/Images(1).png"        // public/images/winch.jpg
  },
  {
    id: 2,
    name: "CYCLO GEAR MOTOR",
    category: "GEAR MOTOR",
    image: "/images/Images(2).png"        // public/images/winch.jpg
  },
  {
    id: 3,
    name: "REDUCTION GEAR MOTOR",
    category: "GEAR MOTOR",
    image: "/images/Images(3).png"        // public/images/winch.jpg
  },
    {
    id: 8,
    name: "CYCLONE GEAR MOTOR",
    category: "GEAR MOTOR",
    image: "/images/Images(8).png"        // public/images/winch.jpg
  },
    {
    id: 9,
    name: "CYCLONE GEAR MOTOR",
    category: "GEAR MOTOR",
    image: "/images/Images(9).png"        // public/images/winch.jpg
  },
   {
    id: 10,
    name: "ALIGER GEAR MOTOR",
    category: "GEAR MOTOR",
    image: "/images/Images(10).png"        // public/images/winch.jpg
  },
   {
    id: 22,
    name: "CYCLONE GEAR MOTOR ",
    category: "GEAR MOTOR",
    image: "/images/Images(33).png"        // public/images/winch.jpg
  },
   
   {
    id: 25,
    name: "GEAR MOTOR",
    category: "GEAR MOTOR",
    image: "/images/Images(36).png"        // public/images/winch.jpg
  },
  
     {
    id: 21,
     name: "ALIGER GEAR",
    category: "GEAR",
    image: "/images/Images(32).jpeg"        // public/images/winch.jpg
  },
  
 {
    id: 19,
    name: "ALIGER GEAR",
    category: "GEAR",
    image: "/images/Images(30).png"        // public/images/winch.jpg
  },
 
  
  {
    id: 17,
    name: "BUTTERFLY VALVE",
    category: "OTHERS",
    image: "/images/Images(24).jpeg"        // public/images/winch.jpg
  },
  
  
 
  
  {
    id: 20,
    name: "CHAIN BLOCK",
    category: "OTHERS",
    image: "/images/Images(31).png"     // public/images/winch.jpg
  },
  {
    id: 4,
    name: "ELECTRIC  CHAIN OF HOIST",
    category: "OTHERS",
    image: "/images/Images(4).png"        // public/images/winch.jpg
  },
 
  
 
 
  
 {
    id: 42,
    name: "BLOWER",
    category: "OTHERS",
    image: "/images/Images(42).png"        // public/images/winch.jpg
  },
  
];
